export function displayTitle(titles: any, defaultLanguage: string): string {
  const filteredTitles = titles
    .filter((item: any) => item.language === defaultLanguage);

  if (filteredTitles.length > 0) {
    return filteredTitles.map((item: any) => item.name);
  } else {
    return titles
      .filter((item: any) => item.language === "en")
      .map((item: any) => item.name);
  }
}


export function formatDynamicPricingCell(
  headers: any,
  index: number,
  cell: any,
  currency: string
): string {
  const header = headers?.[index];
  const isCost = header?.isCostColumn;
  const curr = (currency).toUpperCase();

  // Case 1: If the cell is empty or null
  if (!cell || cell === "") { return ""; }

  // Case 2: If it's a cost column, prefix with currency
  if (isCost) { return `${curr} ${cell}`; }

  // Case 3: Otherwise just return the value
  return `${cell}`;
}
